import moment from 'moment';
import { isDefined, getHyphenDateFormat } from './utils';
import Resources from './resources';

export const MOMENT_DEFAULT_FORMAT = 'DD/MMM/YYYY HH:mm';
export const MOMENT_DATE_FORMAT = 'DD/MMM/YYYY';
export const MOMENT_TIME_FORMAT = 'HH:mm';
export const START_TIME = '00:00';

export function getDataFromResponse(res) {
  return isDefined(res) && isDefined(res.data) ? res.data : undefined;
}

export function getDateFromStartPreference(preference) {
  switch (preference) {
    // Start of next day
    case '1':
      return [moment().add(1, 'day').format(MOMENT_DATE_FORMAT), START_TIME];
    // The next Monday, at midnight
    case '2':
      return [moment().day(8).format(MOMENT_DATE_FORMAT), START_TIME];
    // Now
    case '0':
      return [
        moment().format(MOMENT_DATE_FORMAT),
        moment().format(MOMENT_TIME_FORMAT)
      ];
    default:
      return undefined;
  }
}

export function getDateFromDuePreference(startDate, preference) {
  startDate = getHyphenDateFormat(startDate);
  switch (preference) {
    // Due in one hour
    case '1':
      return [
        moment(startDate).add(1, 'hour').format(MOMENT_DATE_FORMAT),
        moment().add(1, 'hour').format(MOMENT_TIME_FORMAT)
      ];
    // Due in one day
    case '2':
      return [
        moment(startDate).add(1, 'day').format(MOMENT_DATE_FORMAT),
        moment().set({ hours: 17, minutes: 0 }).format(MOMENT_TIME_FORMAT)
      ];
    // Due in 2 days
    case '3':
      return [
        moment(startDate).add(2, 'days').format(MOMENT_DATE_FORMAT),
        moment().set({ hours: 17, minutes: 0 }).format(MOMENT_TIME_FORMAT)
      ];
    // Due in one week
    case '4':
      return [
        moment(startDate).add(1, 'week').format(MOMENT_DATE_FORMAT),
        moment().set({ hours: 17, minutes: 0 }).format(MOMENT_TIME_FORMAT)
      ];
    // Due in two weeks
    case '5':
      return [
        moment(startDate).add(2, 'weeks').format(MOMENT_DATE_FORMAT),
        moment().set({ hours: 17, minutes: 0 }).format(MOMENT_TIME_FORMAT)
      ];
    // No due date
    case '0':
    default:
      return undefined;
  }
}

export function mapSelectedActivitiesToReq(selectedActivities) {
  const activityMap = new Map();
  const requestObj = {
    studentWithActivities: []
  };
  selectedActivities.forEach((activity) => {
    const currentMap = activityMap.get(activity.encryptedUserProfileId) || [];
    activityMap.set(activity.encryptedUserProfileId, [
      ...currentMap,
      {
        activityTaskId: activity.activityId,
        taskType: activity.taskType
      }
    ]);
  });

  activityMap.forEach((value, key) => {
    requestObj.studentWithActivities.push({
      encryptedUserProfileId: key,
      activitiesToAssign: value
    });
  });
  return requestObj;
}

export function retrieveAssignedTaskId(selectedAssignments) {
  return selectedAssignments.map(
    (selectedAssignment) => selectedAssignment.assignment.assignedTaskId
  );
}

export async function getDatePreference() {
  const datePreference = [];
  await Resources.getStartDatePreference
    .get()
    .send()
    .then((startRes) => {
      const startData = getDataFromResponse(startRes);
      if (startData) {
        const startPreference = getDateFromStartPreference(
          startData.preferredValue
        );
        datePreference.push(startPreference);
        Resources.getDueDatePreference
          .get()
          .send()
          .then((dueRes) => {
            const dueData = getDataFromResponse(dueRes);
            if (dueData) {
              datePreference.push(
                getDateFromDuePreference(
                  startPreference[0],
                  dueData.preferredValue
                )
              );
            }
          });
      }
    });
  return datePreference;
}



// WEBPACK FOOTER //
// ./helpers/resources-helper.js